var scope_0 = require('/builds/pentech.hu/documentation-of-integrations/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/115d32723d2cdfd7518c268515106f62.js').default;
var scope_1 = require('/builds/pentech.hu/documentation-of-integrations/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7492d1ec1171d73677883dcd7eb030d3.js').default;
var scope_2 = require('/builds/pentech.hu/documentation-of-integrations/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    